import { render, staticRenderFns } from "./CollegeCollect.vue?vue&type=template&id=65fa4cb7&scoped=true&"
import script from "./CollegeCollect.vue?vue&type=script&lang=js&"
export * from "./CollegeCollect.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCollect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CollegeCollect.vue?vue&type=style&index=1&id=65fa4cb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa4cb7",
  null
  
)

export default component.exports